module.exports = __webpack_public_path__ + "static/media/video-test-poster.7210f7ba.jpg";